import { render, staticRenderFns } from "./PopProductTechnical.vue?vue&type=template&id=8cb6cb00&scoped=true&"
import script from "./PopProductTechnical.vue?vue&type=script&lang=js&"
export * from "./PopProductTechnical.vue?vue&type=script&lang=js&"
import style0 from "./PopProductTechnical.vue?vue&type=style&index=0&id=8cb6cb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb6cb00",
  null
  
)

export default component.exports